import type { JssStyle } from 'jss';
import type { WebWidgetEntity } from '@web/types';
import type { LineWidgetData } from '@web/widgets/line/type/line-widget.type';

import { EHorizontalPosition } from '@common/enums';

import { websiteColorCss } from '@libs/themes/src/variants/website/utils/variables';

export function getStyles(widget: WebWidgetEntity<LineWidgetData>): JssStyle {
    const lineHorizontalAlignMap = {
        [EHorizontalPosition.L]: {
            marginLeft: 0,
            marginRight: 'auto',
        },
        [EHorizontalPosition.M]: {
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        [EHorizontalPosition.R]: {
            marginLeft: 'auto',
            marginRight: 0,
        },
    };
    const { data, styles } = widget;

    const lineWrapper: JssStyle = {
        margin: styles.margin,
    };

    const line: JssStyle = {
        borderTopColor: websiteColorCss(styles.borderTopColor as string),
        borderTopStyle: `${styles.borderTopStyle}`,
        borderTopWidth: `${styles.borderTopWidth}px`,
        marginTop: '10px',
        marginBottom: '10px',
        width: `${styles.width}%`,
        ...lineHorizontalAlignMap[data.horizontalAlign || EHorizontalPosition.M],
    };

    const lineSafari: JssStyle = {
        overflow: 'hidden',
        width: `${styles.width}%`,
        ...lineHorizontalAlignMap[data.horizontalAlign || EHorizontalPosition.M],
        '&:after': {
            content: '"●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●"',
            letterSpacing: `${(+styles.borderTopWidth * 0.5)}px`,
            fontSize: `${(+styles.borderTopWidth * 2)}px`,
            lineHeight: `${styles.borderTopWidth}px`,
            marginTop: '10px',
            marginBottom: '10px',
            color: websiteColorCss(styles.borderTopColor as string),
            display: 'block',
            height: `${styles.borderTopWidth}px`,
        },
    }

    return {
        lineWrapper,
        line,
        lineSafari,
    };
}
